// src/hooks/useSocialDetails.js
import { useState, useEffect } from "react";
import { doc, getDoc } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";

var cache = null;

export function useSocialDetails() {
  var [data, setData]       = useState(cache || {});
  var [loading, setLoading] = useState(!cache);

  useEffect(function() {
    if (cache) { setData(cache); setLoading(false); return; }
    getDoc(doc(db, "siteSettings", "socialDetails"))
      .then(function(snap) {
        var d = snap.exists() ? snap.data() : {};
        cache = d;
        setData(d);
      })
      .catch(function() { setData({}); })
      .finally(function() { setLoading(false); });
  }, []);

  return { data: data, loading: loading };
}
